import React, { useState, useEffect } from "react";
import { Navigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "./Layout";
import axios from "axios";
import DocumentList from "../components/DocumentList";
import PageLoaderComp from "../component/pageLoaderComp";
import { useParams } from "react-router-dom";

const Completeformalites = () => {
  const [dossiers, setDossiers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [newdocuments, setnewDocuments] = useState([]);
  const [currentstep, setcurrentstep] = useState(1);
  const currentUser = useSelector((state) => state.authentication.user);
  const { id } = useParams();

  const steps = [
    { number: 1, label: "Dossier" },
    { number: 2, label: "Analyse" },
    { number: 3, label: "Modification" },
    { number: 4, label: "Validation" },
  ];

  useEffect(() => {
    const fetchDossiers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}api/prouser/dossiers/${id}`
        );
        if (response.status === 200 && response.data.success) {
          setDossiers(response.data.data);
          // Map uploaded files to their corresponding documents
          console.log('response.data.selservicefile', response.data.data);
          setcurrentstep(response.data.data[0].status);
          //console.log('currentstep',currentstep);
          if (response.data.selservicefile) {
            const uploadedFiles = response.data.selservicefile;
            const updatedDocuments = Object.entries(documentuploads).map(
              ([key, doc]) => {
                const uploadedFile = uploadedFiles.find(
                  (file) => file.docId === doc.name
                );
                return {
                  ...doc,
                  status: uploadedFile ? "Validé" : "",
                  uploaded_file: uploadedFile || null,
                };
              }
            );
            setnewDocuments(uploadedFiles);
            setDocuments(updatedDocuments);
            // console.log('updatedDocuments',updatedDocuments);
          }
        }
      } catch (err) {
        setError("Error fetching dossiers");
      } finally {
        setLoading(false);
      }
    };
    fetchDossiers();
  }, [currentUser, id]);
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
//console.log('dossiers-dossiers',dossiers[0].invoice_pdf);
  // if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  const documentSets = {
    //sarl/eurl
    statuts_maj: {
      name: "statuts_maj",
      title: "Statuts de la société",
      description:"Document fondateur définissant les règles de fonctionnement de la société. Il doit être paraphé, daté et signé par tous les associés ou l'associé unique.",
      icon:"../images/icon/document1.png",
      formats: [".PDF"],
      position: 1,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    pv: {
      name: "pv",
      title: "Procès-verbal de l'assemblée générale constitutive",
      description:"Document fondateur définissant les règles de fonctionnement de la société.",
      icon:"../images/icon/document2.png",
      formats: [".PDF"],
      position: 2,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    piece_identite_representant_legal_actuel: {
      name: "piece_identite_representant_legal_actuel",
      title: "Pièce d'identité du représentant légal",
      description:"Avec la mention manuscrite 'certifiée conforme à l'original par le représentant légal' daté et signé par le représentant légal.",
      icon:"../images/icon/document3.png",
      formats: [".PDF"],
      position: 3,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    attestation_non_condamnation_filiation: {
      name: "attestation_non_condamnation_filiation",
      title: "Attestation de non-condamnation et de filiation",
      description:" Déclaration sur l'honneur attestant que le dirigeant n'a pas fait l'objet de condamnation et précisant sa filiation",
      icon:"../images/icon/document4.png",
      formats: [".PDF",".DOCX"],
      position: 4,
      url: ["/dossierfiles/pdf/DNC.pdf","/dossierfiles/docs/DNC.doc"],
    },
    justificatif_nouveau_siege: {
      name: "justificatif_nouveau_siege",
      title: "Justificatif de domiciliation du siège social",
      description:"Contrat de domiciliation, bail ou attestation d'hébergement accompagnée d'un justificatif de domicile.",
      icon:"../images/icon/document5.png",
      formats: [".PDF"],
      position: 5,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    attestation_de_depot_des_fonds: {
      name: "attestation_de_depot_des_fonds",
      title: "Attestation de dépôt des fonds",
      description:"Document délivré par la banque confirmant le dépôt du capital social.",
      icon:"../images/icon/document6.png",
      formats: [".PDF"],
      position: 6,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    acte_designation_representant_legal: {
      name: "acte_designation_representant_legal",
      title: "Acte de désignation du représentant légal",
      description:"Document désignant formellement le représentant légal, si ce n’est pas mentionné dans les statuts.",
      icon:"../images/icon/document7.png",
      formats: [".PDF"],
      position: 7,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    justificatif_dautorisation_dexercice_si_activite_reglementee: {
      name: "justificatif_dautorisation_dexercice_si_activite_reglementee",
      title: "Justificatif d'autorisation d'exercice (si activité réglementée)",
      description:"Licence ou autorisation administrative nécessaire pour certaines activités.",
      icon:"../images/icon/document8.png",
      formats: [".PDF"],
      position: 8,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    pouvoir: {
      name: "pouvoir",
      title: "Procuration signée (Busyplace)",
      description:"Procuration signée par le client autorisant Busyplace à effectuer les formalités en son nom.",
      icon:"../images/icon/document9.png",
      formats: [".PDF",".DOCX"],
      position: 9,
      url: [`/dossierfiles/pdf/Busyplace-Pouvoir.pdf`,`/dossierfiles/docs/Busyplace-Pouvoir.doc`],
    },

    //sas/sasu
    liste_des_souscripteurs: {
      name: "liste_des_souscripteurs",
      title: "Liste des souscripteurs",
      description:"Document mentionnant l'identité des actionnaires, le nombre d'actions souscrites et les sommes versées par chacun.",
      icon:"../images/icon/document8.png",
      formats: [".PDF"],
      position: 3,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    
    //modification
    statuts_maj_modification: {
      name: "statuts_maj_modification",
      title: "Statuts de la société (Modifiés)",
      description:"Téléchargez la version mise à jour des statuts, après modification de l'objet social, capital ou dirigeant",
      icon:"../images/icon/document1.png",
      formats: [".PDF"],
      position: 1,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },

    pv_modification: {
      name: "pv_modification",
      title: "Procès-verbal de l'assemblée générale (si nécessaire)",
      description:"Acte officiel validant la modification de la société. Téléchargez-le si l'assemblée générale a eu lieu.",
      icon:"../images/icon/document2.png",
      formats: [".PDF"],
      position: 2,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    piece_identite_representant_legal_actuel_modification: {
      name: "piece_identite_representant_legal_actuel_modification",
      title: "Pièce d'identité du représentant légal",
      description:"Copie de la pièce d'identité en cours de validité du représentant légal.",
      icon:"../images/icon/document3.png",
      formats: [".PDF"],
      position: 3,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    attestation_condamnation_filiation_modification: {
      name: "attestation_condamnation_filiation_modification",
      title: "Attestation de non-condamnation et de filiation",
      description:"Déclaration sur l'honneur attestant qu'aucune condamnation n'a été prononcée contre le dirigeant.",
      icon:"../images/icon/document4.png",
      formats: [".PDF",".DOCX"],
      position: 4,
      url: ["/dossierfiles/pdf/DNC.pdf","/dossierfiles/docs/DNC.doc"],
    },
    justificatif_nouveau_siege_modification: {
      name: "justificatif_nouveau_siege_modification",
      title: "Justificatif de domiciliation du siège social (si changement d'adresse)",
      description:"Document prouvant la nouvelle adresse du siège social de la société, en cas de changement.",
      icon:"../images/icon/document5.png",
      formats: [".PDF"],
      position: 5,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    attestation_depot_fonds_modification: {
      name: "attestation_depot_fonds_modification",
      title: "Attestation de dépôt des fonds",
      description:"Document attestant du dépôt du capital social, en cas de modification de ce dernier.",
      icon:"../images/icon/document6.png",
      formats: [".PDF"],
      position: 6,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    acte_designation_nouveau_representant_legale_modification: {
      name: "acte_designation_nouveau_representant_legale_modification",
      title: "Acte de désignation du nouveau représentant légal (si applicable)",
      description:"Téléchargez si un nouveau représentant légal a été nommé par l'assemblée générale.",
      icon:"../images/icon/document7.png",
      formats: [".PDF"],
      position: 7,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    justificatif_autorisation_exercice_activite_reglementee_modification: {
      name: "justificatif_autorisation_exercice_activite_reglementee_modification",
      title: "Justificatif d'autorisation d'exercice (si activité réglementée)",
      description:"Téléchargez une licence ou autorisation administrative pour les activités nécessitant une régulation particulière.",
      icon:"../images/icon/document8.png",
      formats: [".PDF"],
      position: 8,
      url: ["https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf"],
    },
    pouvoir_modification: {
      name: "pouvoir_modification",
      title: "Procuration signée (Busyplace)",
      description:" Téléchargez la procuration signée par le client autorisant BusyPlace à effectuer les formalités de modification en son nom.",
      icon:"../images/icon/document9.png",
      formats: [".PDF",".DOCX"],
      position: 9,
      url: [`/dossierfiles/pdf/Busyplace-Pouvoir.pdf`,`/dossierfiles/docs/Busyplace-Pouvoir.doc`],
    },

    //dissolution

    pv_de_dissolution: {
      name: "pv_de_dissolution",
      title: "PV de dissolution",
      description:"Acte officiel validant la décision de dissolution de la société. Ce document doit être signé par les dirigeants et approuvé en assemblée générale.",
      icon:"../images/icon/document1.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
  
    pi_du_president: {
      name: "pi_du_president",
      title: "Pièce d'identité du Président",
      description:"Copie de la pièce d'identité en cours de validité (carte d'identité ou passeport) du Président de la société.",
      icon:"../images/icon/document2.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    pouvoir_dissolution: {
      name: "pouvoir_dissolution",
      title: "Pouvoir signé",
      description:"Mandat signé autorisant un tiers à agir en nom du Président pour la soumission des documents relatifs à la dissolution.",
      icon:"../images/icon/document3.png",
      formats: ["PDF"],
      position: 10,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },


    pv_de_dissolution_societe: {
      name: "pv_de_dissolution_societe",
      title: "PV de dissolution",
      description:"Acte validant la dissolution de la société.",
      icon:"../images/icon/document4.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    piece_didentite_des_associes: {
      name: "piece_didentite_des_associes",
      title: "Pièce d'identité des Associés",
      description:"Copie des pièces d'identité en cours de validité des associés.",
      icon:"../images/icon/document5.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    declaration_non_condamnation_associe: {
      name: "declaration_non_condamnation_associe",
      title: "Déclaration de non-condamnation Associé",
      description:"Déclaration sur l'honneur attestant que l'associé n'a pas fait l'objet de condamnation ou de procédure judiciaire en cours.",
      icon:"../images/icon/document6.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    pouvoir_dissolution_associes: {
      name: "pouvoir_dissolution_associes",
      title: "Pouvoir signé",
      description:"Mandat autorisant un tiers à agir en nom des associés pour la soumission des documents.",
      icon:"../images/icon/document7.png",
      formats: ["PDF"],
      position: 10,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

  
    pi_du_tiers: {
      name: "pi_du_tiers",
      title: "Pièce d'identité du Tiers",
      description:"Copie de la pièce d'identité du tiers intervenant dans le cadre de la dissolution.",
      icon:"../images/icon/document8.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    declaration_non_condamnation_tiers: {
      name: "declaration_de_non_condamnation_tiers",
      title: "Déclaration de non-condamnation du Tiers",
      description:"Déclaration sur l'honneur attestant que le tiers n’a pas fait l'objet de condamnation ou de procédure judiciaire en cours.",
      icon:"../images/icon/document9.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    justificatif_domicile_tiers: {
      name: "justificatif_domicile_tiers",
      title: "Justificatif de domicile du Tiers",
      description:"Document officiel prouvant l'adresse de résidence du tiers (facture EDF, quittance de loyer, etc.).",
      icon:"../images/icon/document1.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    pouvoir_dissolution_tiers: {
      name: "pouvoir_dissolution_tiers",
      title: "Pouvoir signé",
      description:"Mandat autorisant un tiers à agir au nom du représentant légal pour la soumission des documents.",
      icon:"../images/icon/document2.png",
      formats: ["PDF"],
      position: 10,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },


  
    justificatif_domicile_liquidateur: {
      name: "justificatif_domicile_liquidateur",
      title: "Justificatif de domicile du liquidateur",
      description:"Document prouvant l’adresse du liquidateur (facture EDF, quittance de loyer, etc.).",
      icon:"../images/icon/document3.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
  
    pv_de_liquidation: {
      name: "pv_de_liquidation",
      title: "PV de liquidation",
      description:"Acte validant la liquidation de la société.",
      icon:"../images/icon/document4.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
  
    bilan_de_cloture: {
      name: "bilan_de_cloture",
      title: "Bilan de clôture",
      description:"Bilan des finances de la société à la clôture de l’activité.",
      icon:"../images/icon/document5.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
  
    attestation_urssaf: {
      name: "attestation_urssaf",
      title: "Attestation URSSAF",
      description:"Certificat prouvant que la société a réglé toutes ses cotisations sociales et ses obligations auprès de l’URSSAF.",
      icon:"../images/icon/document6.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
  
    attestation_impot: {
      name: "attestation_impot",
      title: "Attestation Impôt",
      description:"Certificat prouvant que la société a réglé toutes ses obligations fiscales avant la liquidation.",
      icon:"../images/icon/document7.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    pouvoir_liquidation: {
      name: "pouvoir_liquidation",
      title: "Pouvoir signé",
      description:"Mandat pour autoriser un tiers à agir au nom du liquidateur ou représentant légal.",
      icon:"../images/icon/document8.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    piece_didentite_president_liquidation: {
      name: "piece_didentite_president_liquidation",
      title: "Pièce d'identité du Président",
      description:"Copie de la pièce d'identité en cours de validité du Président de la société.",
      icon:"../images/icon/document9.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    pouvoir_liquidation_president: {
      name: "pouvoir_liquidation_president",
      title: "Pouvoir signé",
      description:"Mandat autorisant un tiers à agir en nom du Président pour les formalités de liquidation.",
      icon:"../images/icon/document1.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    piece_didentite_associes: {
      name: "piece_didentite_associes",
      title: "Pièce d'identité des Associés",
      description:"Copies des pièces d'identité des associés de la société.",
      icon:"../images/icon/document2.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    declaration_de_non_condamnation_associe: {
      name: "declaration_de_non_condamnation_associe",
      title: "Déclaration de non-condamnation Associé",
      description:"Déclaration sur l'honneur des associés attestant qu’ils ne font pas l’objet de condamnations ou de procédures judiciaires.",
      icon:"../images/icon/document3.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    pouvoir_liquidation_associes: {
      name: "pouvoir_liquidation_associes",
      title: "Pouvoir signé",
      description:"Mandat autorisant un tiers à agir en nom des associés pour la soumission des documents nécessaires.",
      icon:"../images/icon/document4.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    piece_didentite_tiers: {
      name: "piece_didentite_tiers",
      title: "Pièce d'identité du Tiers",
      description:"Copie de la pièce d'identité du tiers intervenant dans la liquidation.",
      icon:"../images/icon/document5.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    declaration_de_non_condamnation_tiers: {
      name: "declaration_de_non_condamnation_tiers",
      title: "Déclaration de non-condamnation du Tiers",
      description:"Déclaration sur l'honneur attestant que le tiers n’a pas fait l’objet de condamnations ou de procédures judiciaires en cours.",
      icon:"../images/icon/document6.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    justificatif_domicile_liquidateur_tiers: {
      name: "justificatif_domicile_liquidateur_tiers",
      title: "Justificatif de domicile du Tiers",
      description:"Document officiel prouvant l'adresse de résidence du tiers.",
      icon:"../images/icon/document7.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    pouvoir_liquidation_liquidateur_tiers: {
      name: "pouvoir_liquidation_liquidateur_tiers",
      title: "Pouvoir signé",
      description:"Mandat autorisant un tiers à agir au nom du liquidateur ou du représentant légal dans le cadre de la liquidation.",
      icon:"../images/icon/document8.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },



    pv_de_dissolution_et_liquidation: {
      name: "pv_de_dissolution_et_liquidation",
      title: "PV de dissolution et liquidation",
      description:"Acte validant la dissolution et la liquidation simultanée de la société.",
      icon:"../images/icon/document9.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    
    bilan_de_cloture_liquidation: {
      name: "bilan_de_cloture_liquidation",
      title: "Bilan de clôture",
      description:"Bilan financier final des comptes de la société.",
      icon:"../images/icon/document1.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    attestation_urssaf_liquidation: {
      name: "attestation_urssaf_liquidation",
      title: "Attestation URSSAF",
      description:"Preuve que toutes les cotisations sociales ont été réglées auprès de l'URSSAF.",
      icon:"../images/icon/document2.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    attestation_impot_liquidation: {
      name: "attestation_impot_liquidation",
      title: "Attestation Impôt",
      description:"Certificat prouvant le paiement de tous les impôts dus avant la liquidation.",
      icon:"../images/icon/document3.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    pouvoir_liquidation_dissolution: {
      name: "pouvoir_liquidation_dissolution",
      title: "Pouvoir signé",
      description:"Mandat autorisant un tiers à agir au nom du liquidateur ou du représentant légal dans le cadre de la liquidation.",
      icon:"../images/icon/document4.png",
      formats: ["PDF"],
      position: 1,
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },


    //for formality

    pv_agoa: {
      name: "pv_agoa",
      title: "PV AGO (Assemblée générale ordinaire)",
      description:"Procès-verbal validant les décisions prises lors de l'assemblée générale ordinaire, incluant les approbations des comptes.",
      icon:"../images/icon/document1.png",
      formats: ["PDF"],
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    propositions_affectation_resultat: {
      name: "propositions_affectation_resultat",
      title: "Propositions d’affectation de résultat",
      description:"Document détaillant la manière dont les bénéfices ou pertes de la société seront affectés (répartition des dividendes, report à nouveau, etc.).",
      icon:"../images/icon/document2.png",
      formats: ["PDF"],
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    bilan: {
      name: "bilan",
      title: "Bilan",
      description:"Bilan financier de la société pour l'année concernée, montrant les actifs, passifs et le capital.",
      icon:"../images/icon/document3.png",
      formats: ["PDF"],
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    compte_de_resultat: {
      name: "compte_de_resultat",
      title: "Compte de résultat",
      description:"Document détaillant les performances financières de la société, y compris les revenus, dépenses et résultats.",
      icon:"../images/icon/document4.png",
      formats: ["PDF"],
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    propositions_affectation_resultat_oui: {
      name: "propositions_affectation_resultat_oui",
      title: "Propositions d’affectation de résultat",
      description:"Document détaillant la manière dont les bénéfices ou pertes de la société seront affectés.",
      icon:"../images/icon/document2.png",
      formats: ["PDF"],
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    bilan_oui: {
      name: "bilan_oui",
      title: "Bilan",
      description:"Bilan financier de la société pour l'année concernée.",
      icon:"../images/icon/document3.png",
      formats: ["PDF"],
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },

    compte_de_resultat_oui: {
      name: "compte_de_resultat_oui",
      title: "Compte de résultat",
      description:"Document détaillant les performances financières de la société.",
      icon:"../images/icon/document4.png",
      formats: ["PDF"],
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
    declaration_confidentialite: {
      name: "declaration_confidentialite",
      title: "Déclaration de confidentialité",
      description:"Document confirmant que la confidentialité des informations financières sera maintenue et ne sera pas partagée publiquement.",
      icon:"../images/icon/document6.png",
      formats: ["PDF"],
      url: "https://certi.legals.fr/download_pdf.php?file=formfiles/Immatriculation/MBE_Societes.pdf",
    },
   
  };

  const currentDossier = dossiers && dossiers.length > 0 ? dossiers[0] : null;
  let createurl = `${process.env.REACT_APP_EXPERT_URL}`;
  const documentuploads = [];

  if (currentDossier !== null) {
    const formdata = JSON.parse(currentDossier.formdata);
    if (currentDossier.formtype === "sarl-eurl") 
    {
      createurl =
      `${process.env.REACT_APP_EXPERT_URL}/creation/sarl-eurl?formId=${currentDossier.id}`;
      documentuploads.push(documentSets.statuts_maj);
      documentuploads.push(documentSets.pv);
      documentuploads.push(documentSets.piece_identite_representant_legal_actuel);
      documentuploads.push(documentSets.attestation_non_condamnation_filiation);
      documentuploads.push(documentSets.justificatif_nouveau_siege);
      documentuploads.push(documentSets.attestation_de_depot_des_fonds);
      documentuploads.push(documentSets.acte_designation_representant_legal);
      documentuploads.push(documentSets.justificatif_dautorisation_dexercice_si_activite_reglementee);
      documentuploads.push(documentSets.pouvoir);
    }
    if(currentDossier.formtype === "SAS/SASU") 
    {
      createurl =
      `${process.env.REACT_APP_EXPERT_URL}/creation/sas-sasu?formId=${currentDossier.id}`;
      documentuploads.push(documentSets.statuts_maj);
      documentuploads.push(documentSets.pv);
      documentuploads.push(documentSets.liste_des_souscripteurs);
      documentuploads.push(documentSets.piece_identite_representant_legal_actuel);
      documentuploads.push(documentSets.attestation_non_condamnation_filiation);
      documentuploads.push(documentSets.justificatif_nouveau_siege);
      documentuploads.push(documentSets.attestation_de_depot_des_fonds);
      documentuploads.push(documentSets.acte_designation_representant_legal);
      documentuploads.push(documentSets.justificatif_dautorisation_dexercice_si_activite_reglementee);
      documentuploads.push(documentSets.pouvoir);
    }
    if (currentDossier.formtype === "sci") 
    {
      createurl = `${process.env.REACT_APP_EXPERT_URL}/creation/sci?formId=${currentDossier.id}`;
      documentuploads.push(documentSets.statuts_maj);
      documentuploads.push(documentSets.pv);
      documentuploads.push(documentSets.piece_identite_representant_legal_actuel);
      documentuploads.push(documentSets.attestation_non_condamnation_filiation);
      documentuploads.push(documentSets.justificatif_nouveau_siege);
      documentuploads.push(documentSets.attestation_de_depot_des_fonds);
      documentuploads.push(documentSets.acte_designation_representant_legal);
      documentuploads.push(documentSets.pouvoir);
    }
    if (currentDossier.formtype === "modification") {
      createurl = `${process.env.REACT_APP_EXPERT_URL}/modification?formId=${currentDossier.id}`;
      documentuploads.push(documentSets.statuts_maj_modification);
      documentuploads.push(documentSets.pv_modification);
      documentuploads.push(documentSets.piece_identite_representant_legal_actuel_modification);
      documentuploads.push(documentSets.attestation_condamnation_filiation_modification);
      documentuploads.push(documentSets.justificatif_nouveau_siege_modification);
      documentuploads.push(documentSets.attestation_depot_fonds_modification);
      documentuploads.push(documentSets.acte_designation_nouveau_representant_legale_modification);
      documentuploads.push(documentSets.justificatif_autorisation_exercice_activite_reglementee_modification);
      documentuploads.push(documentSets.pouvoir_modification);
    }

    if (currentDossier.formtype === "dissolution") 
    {
      createurl = `${process.env.REACT_APP_EXPERT_URL}/dissolution?formId=${currentDossier.id}`;
      
      if (formdata.timeline == "dissolutiononly" && formdata.liquidator == "president") {
        documentuploads.push(documentSets.pv_de_dissolution);
        documentuploads.push(documentSets.pi_du_president);
        documentuploads.push(documentSets.pouvoir_dissolution);
      }

      if (formdata.timeline == "dissolutiononly" && formdata.liquidator == "associate") {
        documentuploads.push(documentSets.pv_de_dissolution_societe);
        documentuploads.push(documentSets.piece_didentite_des_associes);
        documentuploads.push(documentSets.declaration_non_condamnation_associe);
        documentuploads.push(documentSets.pouvoir_dissolution_associes);
      }

      if (formdata.timeline == "dissolutiononly" && formdata.liquidator == "third_party") {
        documentuploads.push(documentSets.pv_de_dissolution_societe);
        documentuploads.push(documentSets.pi_du_tiers);
        documentuploads.push(documentSets.declaration_non_condamnation_tiers);
        documentuploads.push(documentSets.justificatif_domicile_tiers);
        documentuploads.push(documentSets.pouvoir_dissolution_tiers);
      }
      if (formdata.timeline == "dissolutiononly" && formdata.liquidationHeadquarters.location == "liquidator_address") {
        documentuploads.push(documentSets.justificatif_domicile_liquidateur);
      }

      if (formdata.timeline == "liquidationonly") 
      {
        documentuploads.push(documentSets.pv_de_liquidation);
        documentuploads.push(documentSets.bilan_de_cloture);
        documentuploads.push(documentSets.attestation_urssaf);
        documentuploads.push(documentSets.attestation_impot);
        documentuploads.push(documentSets.pouvoir_liquidation);

        if (formdata.liquidator == "president") {
          documentuploads.push(documentSets.piece_didentite_president_liquidation);
          documentuploads.push(documentSets.pouvoir_liquidation_president);
        }
        if (formdata.liquidator == "associate") {
          documentuploads.push(documentSets.piece_didentite_associes);
          documentuploads.push(documentSets.declaration_de_non_condamnation_associe);
          documentuploads.push(documentSets.pouvoir_liquidation_associes);
        }
        if (formdata.liquidator == "third_party") {
          documentuploads.push(documentSets.piece_didentite_tiers);
          documentuploads.push(documentSets.declaration_de_non_condamnation_tiers);
          documentuploads.push(documentSets.justificatif_domicile_liquidateur_tiers);
          documentuploads.push(documentSets.pouvoir_liquidation_liquidateur_tiers);
        }
        if (formdata.liquidationHeadquarters.location == "liquidator_address") {
          documentuploads.push(documentSets.justificatif_domicile_liquidateur);
        }
      }
      if (formdata.timeline == "dissolutionandliquidation") 
        {
          documentuploads.push(documentSets.pv_de_dissolution_et_liquidation);
          documentuploads.push(documentSets.bilan_de_cloture_liquidation);
          documentuploads.push(documentSets.attestation_urssaf_liquidation);
          documentuploads.push(documentSets.attestation_impot_liquidation);
          documentuploads.push(documentSets.pouvoir_liquidation_dissolution);
        }
        documentuploads.push(documentSets.pouvoir);
    }
    if (currentDossier.formtype === "formalities") 
    {
      createurl = `${process.env.REACT_APP_EXPERT_URL}/approbation-des-comptes?formId=${currentDossier.id}`;

      if (formdata.exercise.confidentiality == "yes") {
        documentuploads.push(documentSets.pv_agoa);
        documentuploads.push(documentSets.propositions_affectation_resultat_oui);
        documentuploads.push(documentSets.bilan_oui);
        documentuploads.push(documentSets.compte_de_resultat_oui);
        documentuploads.push(documentSets.declaration_confidentialite);
        documentuploads.push(documentSets.pouvoir);
      } else {
        documentuploads.push(documentSets.pv_agoa);
        documentuploads.push(documentSets.propositions_affectation_resultat);
        documentuploads.push(documentSets.bilan);
        documentuploads.push(documentSets.compte_de_resultat);
        documentuploads.push(documentSets.pouvoir);
      }

    }
  }
//console.log('documentuploads-formality',documentuploads);
  const handleDownload = (url, name, format) => {
    const isAbsoluteUrl = url.startsWith('http://') || url.startsWith('https://');
    // If it's a relative URL, prepend the REACT_APP_PRO_URL
    console.log('process.env.REACT_APP_PRO_URL',process.env.REACT_APP_PRO_URL);
    const fullUrl = isAbsoluteUrl ? url : `${process.env.REACT_APP_PRO_URL}${url}`;
    // Create temporary link and trigger download
    const link = document.createElement("a");
    link.href = fullUrl;
    link.target = '_blank'; // Open in new tab if browser blocks download
    link.download = `${name}.${format.toLowerCase()}`; // Normalize extension
    
    // Append link to body, click it, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      {loading ? <PageLoaderComp /> : ""}
      <Layout>
        <div className="mb-8 col-span-12 xl:col-span-9">
          <div className="xl:max-w-[1126px] w-full h-full bg-white md:rounded-[20px]">
            {/* Header */}
            <div className="mainHead min-h-[80px] sm:min-h-[120px] flex sm:flex-row flex-col sm:items-center p-3 sm:p-10 sm:justify-between">
              <div>
                <h1 className="text-lg sm:text-xl md:text-lg xl:text-xl 2xl:text-xl font-extrabold text-white sm:mt-0 mt-4">
                  {currentstep===1 ? "Compléter la formalité " 
                  :currentstep===2 ? "Compléter la formalité "
                  :currentstep===3 ? "Compléter la formalité "
                  :currentstep===4 ? "Formalité accomplie "
                  : "Compléter la formalité"}
                  
                </h1>
              </div>
            </div>

            <div className="p-1 sm:p-6">
              {/* Navigation Bar */}
              <div className="flex items-center justify-between px:2 sm:px-4 py-3 bg-white border-b">
                <div className="flex items-center space-x-1 sm:space-x-4">
                  <Link
                    to="/prouser/mes-dossiers"
                    className="flex items-center text-blue-600 hover:text-blue-700"
                  >
                    <svg
                      className="w-5 h-5 sm:mr-2"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Mon espace
                  </Link>
                </div>
                <div className="flex items-center  space-x-1 sm:space-x-6">
                  <button
                    onClick={() => setIsDocumentPopupOpen(true)}
                    className="flex items-center text-gray-900 hover:text-gray-700"
                  >
                    <svg
                      className="w-5 h-5 mr-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                    Documents
                  </button>
                </div>
              </div>

              {/* Main Content */}
              <div className="bg-white rounded-lg shadow-sm p-2 sm:p-6">
                {/* Dossier Header */}
                <div className="mb-6">
                  <div className="flex justify-between items-center">
                    <h2 className="text-xl font-bold text-[#1a237e]">
                      {currentDossier
                        ? currentDossier.title || "Dossier"
                        : "Approbation des comptes / AGOA · GC INVESTS"}
                    </h2>
                    <span className="text-gray-500">
                      dossier N°{currentDossier ? currentDossier.id : ""}
                    </span>
                  </div>
                </div>

                {/* Stepper */}
                <div className="flex justify-between items-center mb-8">
                  {steps.map((step, index) => (
                    <div key={step.number} className="flex items-center">
                      <div
                        className={`flex flex-col items-center ${
                          index !== steps.length - 1 ? "w-full" : ""
                        }`}
                      >
                        <div
                          className={`relative flex items-center justify-center w-7 h-7 sm:w-10 sm:h-10 rounded-full border-2 
                        ${
                          step.number === currentstep
                            ? "bg-[#fef3c7] border-[#fbbf24] text-[#92400e]"
                            : step.number < currentstep
                            ? "bg-[#bbf7d0] border-[#22c55e] text-[#166534]"
                            : "bg-gray-100 border-gray-300 text-gray-500"
                        }`}
                        >
                          <span className="text-xs sm:text-sm font-medium">
                            {step.number}
                          </span>
                        </div>
                        <span className="mt-2 text-xs sm:text-sm font-medium text-gray-600">
                          {step.label}
                        </span>
                      </div>
                      {index !== steps.length - 1 && (
                        <div
                          className={`w-full h-[2px] mx-1 sm:mx-4 ${
                            step.number < 1 ? "bg-[#22c55e]" : "bg-gray-200"
                          }`}
                        />
                      )}
                    </div>
                  ))}
                </div>

                {/* Content Area */}
                <div className="mt-8">
                  <h3 className="text-lg sm:text-xl font-bold sm:text-center text-[#1a237e] mb-2 sm:mb-4">
                    Merci de finaliser votre dossier
                  </h3>
                  <p className="sm:text-center text-gray-600">
                    Avant analyse par nos équipes, veuillez compléter les
                    informations et joindre les justificatifs requis
                  </p>
                </div>

                {/* Document List */}
                <DocumentList
                  documents={documents.length > 0 ? documents : documentuploads}
                  currentDossier={currentDossier}
                  createurl={createurl}
                  newdocuments={newdocuments}
                />
              </div>

              {/* Document Popup */}
              {isDocumentPopupOpen && (
                <div
                  className="fixed inset-0 z-50 overflow-y-auto bg-[#0000006b] bg-opacity-75"
                  aria-labelledby="modal-title"
                  role="dialog"
                  aria-modal="true"
                >
                  <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div
                      className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                      aria-hidden="true"
                    ></div>
                    <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full">
                      <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                        <div className="flex justify-between items-center mb-4 pb-2 border-[#E5E7EB] border-b">
                          <h3 className="text-lg font-medium text-gray-900">
                            Mes Documents
                          </h3>
                          <button
                            onClick={() => setIsDocumentPopupOpen(false)}
                            className="text-gray-400 hover:text-gray-500"
                          >
                            <svg
                              className="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>
                        <div className="space-y-4">
                          {(documents.length > 0
                            ? documents
                            : documentuploads
                          ).map((doc, index) => (
                            <div
                              key={index}
                              className="flex items-center justify-between py-1"
                            >
                              <div className="flex items-center">
                                <svg
                                  className="w-5 h-5 mr-3 text-gray-400"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                  />
                                </svg>
                                <span className="text-base text-gray-900">
                                  {doc.title} 
                                </span>
                              </div>
                              <div className="flex space-x-2">
                                {doc.formats.map((format, formatIndex) => (
                                  <span
                                    key={formatIndex}
                                    className="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-blue-50 text-blue-600 cursor-pointer hover:bg-blue-100"
                                    onClick={() =>
                                      handleDownload(doc.url[formatIndex], doc.name,format)
                                    }
                                  >
                                    {format}
                                  </span>
                                ))}
                              </div>
                            </div>
                          ))}
                          {dossiers[0].invoice_pdf && ( 
                          <div className="flex items-center justify-between py-2">
                            <div className="flex items-center">
                                <svg
                                  className="w-5 h-5 mr-3 text-gray-400"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                  />
                                </svg>
                                <span className="text-sm text-gray-900">Facture</span>
                            </div>
                            <div className="flex space-x-2">
                              <a className="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-blue-50 text-blue-600 cursor-pointer hover:bg-blue-100" href={dossiers[0].invoice_pdf} target="_blank">PDF</a>
                            </div>
                          </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Completeformalites;
